import type { ReactNode } from 'react';
import { Spinner } from './Spinner';
import { Button } from './Button';

/**
 * Los cuatro estados obligatorios de cualquier vista con datos: cargando,
 * error, vacio y con contenido. Se centralizan aqui para que ninguna pantalla
 * se deje uno sin cubrir.
 */

export function LoadingState({ label = 'Cargando información' }: { label?: string }): ReactNode {
  return (
    <div className="flex min-h-40 items-center justify-center text-muted">
      <Spinner size="lg" label={label} />
    </div>
  );
}

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
}

export function ErrorState({
  title = 'No se pudo cargar la información',
  message,
  onRetry,
}: ErrorStateProps): ReactNode {
  return (
    <div className="rounded-card border border-line bg-surface p-8 text-center">
      <h2 className="text-base font-semibold text-content">{title}</h2>
      <p className="mx-auto mt-1 max-w-md text-sm text-muted">{message}</p>
      {onRetry ? (
        <div className="mt-4">
          <Button variant="secondary" onClick={onRetry}>
            Reintentar
          </Button>
        </div>
      ) : null}
    </div>
  );
}

interface EmptyStateProps {
  title: string;
  message: string;
  action?: ReactNode;
}

export function EmptyState({ title, message, action }: EmptyStateProps): ReactNode {
  return (
    <div className="rounded-card border border-dashed border-line bg-surface p-10 text-center">
      <h2 className="text-base font-semibold text-content">{title}</h2>
      <p className="mx-auto mt-1 max-w-md text-sm text-muted">{message}</p>
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
